import DetailPopup from "./detail-popup";


export default DetailPopup